
import { defineComponent, PropType } from 'vue'
import { formatDecimal } from '@/utils'

export default defineComponent({
  name: 'FormControl',
  props: {
    item: {
      type: Object as PropType<any>,
      required: true
    },
    value: {
      type: [String, Number, Boolean, Array, Date],
      default: undefined
    }
  },
  emits: ['update:value'],
  setup(props, { emit }) {
    const getInputType = (item: any) => {
      // 配置了 decimalPlaces 时，强制用 text，方便控制输入
      if (item.component === 'el-input' && item.decimalPlaces !== undefined) {
        return 'text'
      }
      return item.type
    }

    const handleInput = (val: string | number) => {
      const currentItem = props.item as any
      if (currentItem.component === 'el-input' && currentItem.decimalPlaces != null) {
        const formattedValue = formatDecimal(val, currentItem.decimalPlaces, currentItem.isPositive)
        emit('update:value', formattedValue)
        return
      }

      emit('update:value', val)
    }

    return {
      getInputType,
      handleInput
    }
  }
})
